import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { TitleService } from '../../services/title/title.service';
import { UserAuthService } from '../../services/user/user-auth.service';
import { WancomHttpService } from '../../services/wancom-http/wancom-http.service';
import { MenuContextService } from './services/menu-context.service';
import { MenuExpandContextService } from './services/menu-expand-context.service';
import { LoginDialogComponent } from '../account/login-dialog/login-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Crisp } from 'crisp-sdk-web';
import { WvGuidedTourService } from '../../services/guided-tour/guided-tour.service';

@Component({
    selector: 'wnvw-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
    @ViewChild('sideNav', { static: true })
    sideNav: MatSidenav;

    private deviceInfo: DeviceInfo;
    isMobile = false;
    isTablet = false;
    isDeviceisDesktop = false;

    public isTvIconSelected: boolean = false;
    public isSpotIconSelected: boolean = false;
    public isAccountIconSelected: boolean = false;
    public isTicketIconSelected: boolean = false;
    public isMediaIconSelected: boolean = false;
    public isMoreIconSelected: boolean = false;
    public isStoreIconSelected: boolean = false;
    public isTimelineIconSelected: boolean = false;

    constructor(
        public userService: UserAuthService,
        private http: WancomHttpService,
        public title$: TitleService,
        private deviceService: DeviceDetectorService,
        public menuContext$: MenuContextService,
        public menuExpandContext$: MenuExpandContextService,
        private router: Router,
        public dialog: MatDialog,
        private wvGuidedTour$: WvGuidedTourService,
    ) {}

    async ngOnInit(): Promise<void> {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        // const isDesktopDevice: boolean = this.deviceService.isDesktop();
        if (window.innerWidth <= 900) {
            this.isDeviceisDesktop = false;
        } else {
            this.isDeviceisDesktop = true;
        }

        this.menuContext$.next(true);
        this.menuExpandContext$.next(true);

        if (this.router.url.includes('/park')) {
            this.sendTo(null, 'tv');
        } else if (this.router.url.includes('/spot')) {
            this.sendTo(null, 'spot');
        } else if (this.router.url.includes('/account')) {
            this.sendTo(null, 'account');
        } else if (this.router.url.includes('/store')) {
            this.sendTo(null, 'store');
        }

        
    }

    onResize(event) {
        if (window.innerWidth <= 900) {
            this.isDeviceisDesktop = false;
        } else {
            this.isDeviceisDesktop = true;
        }
    }

    signOut() {
        this.http.signOut();
    }

    sendTo(url: string, icon: string) {
        //reset iconSelected
        this.isTvIconSelected = false;
        this.isSpotIconSelected = false;
        this.isAccountIconSelected = false;
        this.isTicketIconSelected = false;
        this.isMediaIconSelected = false;
        this.isMoreIconSelected = false;
        this.isStoreIconSelected = false;
        this.isTimelineIconSelected = false;

        switch (icon) {
            case 'tv':
                this.isTvIconSelected = true;
                break;
            case 'spot':
                this.isSpotIconSelected = true;
                break;
            case 'account':
                this.isAccountIconSelected = true;
                break;
            case 'ticket':
                this.isTicketIconSelected = true;
                break;
            case 'media':
                this.isMediaIconSelected = true;
                break;
            case 'store':
                this.isStoreIconSelected = true;
                break;
            case 'timeline':
                this.isTimelineIconSelected = true;
                break;
            default:
                break;
        }

        if (url != null) {
            this.router.navigateByUrl(url);
        }
    }

    goToHome() {
        this.router.navigateByUrl('park');
        this.menuContext$.next(true);
        this.menuExpandContext$.next(true);
    }

    editMenuExpandContext() {
        this.menuExpandContext$.next(!this.menuExpandContext$.getValue());
    }

    logIn() {
        const loginDialogRef = this.dialog.open(LoginDialogComponent, {
            closeOnNavigation: true,
            panelClass: 'loginDiag',
            disableClose: true,
        });

        loginDialogRef.afterClosed().subscribe(() => {
            if (this.userService.isLogged()) {
                window.location.reload();
            }
        });
    }
}
